import styled from "styled-components";

export const ContentAndPreviewContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  max-width: 1900px;
  margin: auto;
  gap: 52px;
  padding: 1rem;
  overflow-y: auto;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const ContentContainer = styled.form`
  display: grid;
  max-width: 1440px;
  max-height: 950px;
  overflow-y: auto;
  height: fit-content;
  padding: 1rem;
  gap: 2rem;

  select {
    padding: 1rem;
    font-size: 1rem;
    font-weight: 500;
    border-radius: 8px;
    border: 2px solid ${(props) => props.theme["purple-500"]};
  }

  @media (max-width: 900px) {
    max-height: none;
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
    max-height: none;
  }

  h6 {
    font-size: 0.875rem;
    margin-top: 8px;
    color: ${(props) => props.theme["gray-300"]};
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 100px;
    background: ${(props) => props.theme["gray-50"]};
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 100px;
    background: ${(props) => props.theme["gray-100"]};
  }
`;

export const ContentCreationContainer = styled.div`
  padding: 1rem;
  border-radius: 8px;
  background-color: ${(props) => props.theme["gray-50"]};
  display: grid;
  gap: 1rem;

  h4 {
    width: fit-content;
    font-size: 2rem;
    border-bottom: 3px solid ${(props) => props.theme["purple-500"]};
    margin-bottom: 24px;
  }
`;

interface Props {
  showPreview: boolean;
}

export const PreviewBoxContainer = styled.div<Props>`
  max-height: 900px;
  overflow-y: auto;
  display: ${(props) => (props.showPreview ? "block" : "none")};
  max-width: "900px";
  padding: "1.75rem";
  box-shadow: "0px 2px 6px 4px rgba(0, 0, 0, 0.15)";
  border-radius: "10px";
  padding-bottom: 100px;
  padding-right: 4px;

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 100px;
    background: ${(props) => props.theme["gray-50"]};
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 100px;
    background: ${(props) => props.theme["gray-100"]};
  }

  @media (max-width: 768px) {
    max-height: none;
  }
`;

export const PreviewSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;

  h3 {
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0;
    color: ${(props) => props.theme["gray-300"]};
  }

  p {
    margin: 0;
    font-size: 0.875rem;
    color: ${(props) => props.theme["gray-300"]};
  }
`;
